class BoundaryCheckBase {
    constructor(_parent, _child) {
        this._parent = _parent;
        this._child = _child;
    }
    get parent() {
        return this._parent;
    }
    get child() {
        return this._child;
    }
}
class StrictBoundaryCheck extends BoundaryCheckBase {
    hit() {
        return (this.child.top >= this.parent.top &&
            this.child.left >= this.parent.left &&
            this.child.bottom <= this.parent.bottom &&
            this.child.right <= this.parent.right);
    }
}
class HorizontalBoundaryCheck extends BoundaryCheckBase {
    hit() {
        return (this.child.left >= this.parent.left &&
            this.child.right <= this.parent.right);
    }
}
class VerticalBoundaryCheck extends BoundaryCheckBase {
    hit() {
        return (this.child.top >= this.parent.top &&
            this.child.bottom <= this.parent.bottom);
    }
}
class Boundaries {
    constructor(_parent, _child, _type = 'strict') {
        this._parent = _parent;
        this._child = _child;
        this._type = _type;
    }
    inside() {
        return this._check();
    }
    outside() {
        return !this._check();
    }
    _check() {
        return this._boundary().hit();
    }
    _boundary() {
        switch (this._type) {
            case 'strict':
                return new StrictBoundaryCheck(this._parent, this._child);
            case 'horizontal':
                return new HorizontalBoundaryCheck(this._parent, this._child);
            case 'vertical':
                return new VerticalBoundaryCheck(this._parent, this._child);
        }
    }
}

class TopBoundaryOverstepCheck {
    constructor(_parent, _child, _offset = 0) {
        this._parent = _parent;
        this._child = _child;
        this._offset = _offset;
    }
    check() {
        return this._child.top - this._offset < this._parent.top;
    }
}
class BottomBoundaryOverstepCheck {
    constructor(_parent, _child, _offset = 0) {
        this._parent = _parent;
        this._child = _child;
        this._offset = _offset;
    }
    check() {
        return this._child.bottom + this._offset > this._parent.bottom;
    }
}
class LeftBoundaryOverstepCheck {
    constructor(_parent, _child, _offset = 0) {
        this._parent = _parent;
        this._child = _child;
        this._offset = _offset;
    }
    check() {
        return this._child.left - this._offset < this._parent.left;
    }
}
class RightBoundaryOverstepCheck {
    constructor(_parent, _child, _offset = 0) {
        this._parent = _parent;
        this._child = _child;
        this._offset = _offset;
    }
    check() {
        return this._child.right + this._offset > this._parent.right;
    }
}
class BoundaryOverstep {
    constructor(_parent, _child, _offset = 0) {
        this._parent = _parent;
        this._child = _child;
        this._offset = _offset;
    }
    hasOverstepped(boundary) {
        return this._overstepCheck(boundary).check();
    }
    _overstepCheck(boundary) {
        switch (boundary) {
            case 'top':
                return new TopBoundaryOverstepCheck(this._parent, this._child, this._offset);
            case 'bottom':
                return new BottomBoundaryOverstepCheck(this._parent, this._child, this._offset);
            case 'left':
                return new LeftBoundaryOverstepCheck(this._parent, this._child, this._offset);
            case 'right':
                return new RightBoundaryOverstepCheck(this._parent, this._child, this._offset);
        }
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { BottomBoundaryOverstepCheck, Boundaries, BoundaryOverstep, LeftBoundaryOverstepCheck, RightBoundaryOverstepCheck, TopBoundaryOverstepCheck };
